<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Meal</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field :disabled="true" v-model="editedItem.id" label="ID"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <div>
                                    <template v-if="editedItem.tags !== null" v-for="tag in editedItem.tags">
                                        <v-chip close @input="removeTag(tag)">{{ tag }}</v-chip>
                                    </template>
                                    <v-menu
                                            bottom
                                            origin="center center"
                                            transition="scale-transition"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-chip
                                                    v-on="on"
                                                    color="primary"
                                                    outlined
                                            ><v-icon>add</v-icon>
                                                add tag
                                            </v-chip>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                    v-for="(item, i) in tags"
                                                    :key="i"
                                                    @click="addTagToMeal(item)"
                                            >
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                    <v-text-field v-model="editedItem.day" label="Day - used to group meal together (e.g. 'day 1')"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select :items="tods" v-model="editedItem.tod" label="Time of day"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editedItem.notes" label="Notes"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog=false">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="tagDialog" max-width="400px">
            <v-form ref="tagForm" v-model="valid">
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Create a new tag
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="tagName" label="Tag name" :rules="[v => !!v || 'Name is required']"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="createTag" :disabled="!valid">Create</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="exportDialog" width="290px">
            <v-date-picker v-model="exportDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="exportDialog = false">Cancel</v-btn>
                <v-btn text color="primary" @click="exportMeal" :disabled="!exportDate">Export</v-btn>
            </v-date-picker>
        </v-dialog>

        <v-layout
                text-xs-center
                wrap
        >
            <v-flex xs12>
                <v-card flat class="flat-card">
                    <v-card-title class="pb-0">
                        <v-layout wrap>
                            <v-flex xs12 px-2>
                                <v-subheader class="px-0 mx-0">Filter by tags</v-subheader>
                                <div class="text-xs-left">
                                    <template v-for="tag in tags">
                                        <v-chip :close="close" color="blue-grey" class="mx-1 white--text" @click="searchByTag(tag.name)" @input="deleteTag(tag.name)">{{ tag.name }}</v-chip>
                                    </template>
                                    <v-chip color="blue-grey" outlined class="mx-1 white--text" @click="tagDialog=true"><v-icon>add</v-icon>Create tag</v-chip>
                                    <v-chip color="blue-grey" outlined class="white--text" @click="close=!close"><v-icon>remove</v-icon>Delete tag</v-chip>
                                </div>
                                <v-subheader v-if="searchTag" class="px-0 mx-0">Current filter</v-subheader>
                                <div class="text-xs-left">
                                    <v-chip v-if="searchTag" outlined close color="blue-grey" class="white--text" @click:close="searchTag = null">{{ searchTag }}</v-chip>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-spacer></v-spacer>
                        <div class="text-xs-right">
                            <v-btn v-if="isAllAllowed" @click="openNutritionGraphics" target="_blank" text outlined rounded color="primary" :disabled="selected.length === 0">See nutrition graphic</v-btn>
                            <v-switch v-if="isAllAllowed" label="Show all" v-model="showAll" @change="loadMeals"></v-switch>
                        </div>
                    </v-card-title>

                    <v-card-title>
                        <h3>Meals</h3>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="filter"
                                append-icon="search"
                                label="Filter results"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="mealItems"
                            :search="filter"
                            class="elevation-0">

                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="item in items" :key="item.id" @click="loadVersion(item.id)">
                                    <td class="text-xs-left layout px-0 align-center">
                                        <div v-if="user.role === 1" class="ml-2">
                                            <v-checkbox
                                                    v-model="selected"
                                                    :value="item.id"
                                            ></v-checkbox>
                                        </div>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2 pl-2"
                                                        color="blue"
                                                        @click="openNutritionGraphic(item.id)"
                                                >
                                                    bar_chart
                                                </v-icon>
                                            </template>
                                            <span>Chart</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="blue"
                                                        @click="editItem(item)"
                                                >
                                                    edit
                                                </v-icon>
                                            </template>
                                            <span>Edit item</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="green"
                                                        @click="addToMeal(item)"
                                                >
                                                    file_copy
                                                </v-icon>
                                            </template>
                                            <span>Duplicate meal in new meal</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="red"
                                                        @click="deleteMeal(item.id)"
                                                >
                                                    delete
                                                </v-icon>
                                            </template>
                                            <span>Delete Meal</span>
                                        </v-tooltip>
                                        <v-tooltip top v-if="user.role === 1">
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="primary"
                                                        @click="exportMealDialog(item)"
                                                >
                                                    call_made
                                                </v-icon>
                                            </template>
                                            <span>Export Meal to Kitchen app</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-left">{{ item.id }}</td>
                                    <td class="text-xs-left">{{ item.name }}</td>
                                    <td class="text-xs-left">{{ item.description }}</td>
                                    <td class="text-xs-left">{{ item.day }}</td>
                                    <td class="text-xs-left">{{ getTodText(item.tod) }}</td>
                                    <td class="text-xs-left">
                                        <div><template v-if="item.tags !== null" v-for="(tag, index) in item.tags">{{ index === 0 ? tag : ', ' + tag }}</template></div>
                                    </td>
                                    <td class="text-xs-left">{{ item.notes }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout v-if="user.role === 1 && mealVersions.length > 0">
            <v-flex xs12>
                <v-card flat class="mt-3 flat-card">
                    <v-card-title>
                        <h2>Meal versions</h2>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="filterVersions"
                                append-icon="search"
                                label="Filter results"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="mealVersions"
                            :search="filterVersions"
                            class="elevation-0">

                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td class="text-xs-left layout px-0 align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        slot="activator"
                                                        class="mx-2 pl-2"
                                                        color="blue"
                                                        @click="editItem(item)"
                                                >
                                                    edit
                                                </v-icon>
                                            </template>
                                            <span>Edit item</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        slot="activator"
                                                        class="mx-2"
                                                        color="green"
                                                        @click="addToMeal(item)"
                                                >
                                                    file_copy
                                                </v-icon>
                                            </template>
                                            <span>Duplicate meal in new meal</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        slot="activator"
                                                        class="mx-2"
                                                        color="red"
                                                        @click="deleteMeal(item.id)"
                                                >
                                                    delete
                                                </v-icon>
                                            </template>
                                            <span>Delete Meal</span>
                                        </v-tooltip>
                                        <v-tooltip top v-if="user.role === 1">
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        slot="activator"
                                                        class="mx-2"
                                                        color="primary"
                                                        @click="exportMealDialog(item)"
                                                >
                                                    call_made
                                                </v-icon>
                                            </template>
                                            <span>Export Meal to Kitchen app</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-left">{{ item.id }}</td>
                                    <td class="text-xs-left">{{ item.name }}</td>
                                    <td class="text-xs-left">{{ item.description }}</td>
                                    <td class="text-xs-left">{{ parseDate(item.date) }}</td>
                                    <td class="text-xs-left">{{ getTodText(item.tod) }}</td>
                                    <td class="text-xs-left">
                                        <div><template v-if="item.tags !== null" v-for="(tag, index) in item.tags">{{ index === 0 ? tag : ', ' + tag }}</template></div>
                                    </td>
                                    <td class="text-xs-left">{{ item.notes }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar"
                :timeout="4000"
                :color="snackbarColor"
                top
        >
            <strong>{{ snackbarText }}</strong>
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <v-dialog v-model="chartDialog" fullscreen>
            <v-card v-if="chartDialog">
                <v-app-bar dense fixed dark flat color="transparent">
                    <v-toolbar-title></v-toolbar-title>
                    <v-toolbar-items>
                        <v-btn outlined text rounded @click="chartDialog = false" color="error"><v-icon>close</v-icon>Close</v-btn>
                    </v-toolbar-items>
                    <v-spacer></v-spacer>
                </v-app-bar>
                <v-card-text>
                    <Chart :mealSelection="selected" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import Chart from '../app/init.vue';
  import MealService from '../services/MealService';
  import FoodService from '../services/FoodService';
  import TagService from '../services/TagService';

  export default {
    components: {Chart},
    data: () => ({
      selected: [],
      mealVersions: [],
      showAll: false,
      chartDialog: false,
      tagDialog: false,
      exportDialog: false,
      exportDate: moment().format('YYYY-MM-DD'),
      tagName: null,
      valid: false,
      close: false,
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      dialog: false,
      filter: '',
      filterVersions: '',
      searchTag: null,
      menu: false,
      headers: [
        {sortable: false},
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Day', value: 'day' },
        { text: 'Time of day', value: 'tod' },
        { text: 'Tags', value: 'tags' },
        { text: 'Notes', value: 'notes' }
      ],
      editedItem: {
        id: 0,
        name: '',
        description: ''
      },
      tods: [
        {text: 'Breakfast', value: 1},
        {text: 'Lunch', value: 2},
        {text: 'Dinner', value: 3},
        {text: 'Snacks', value: 4},
        {text: 'Other', value: 5}]
    }),
    async mounted() {
      const response = await MealService.getMeals();
      this.$store.dispatch('setMeals', response.data);
    },
    computed: {
      ...mapGetters({
        tags: 'getMealTags',
        nutrients: 'getNutrients',
        items: 'getMeals',
        user: 'getUser'
      }),
      mealItems() {
        let items = this.items;
        if (this.searchTag !== null && this.searchTag !== '') {
          items = this.items.filter((item) => item.tags ? item.tags.indexOf(this.searchTag) !== -1 : false);
        }
        items = items.filter((item) => (item.date === undefined || item.date === null));
        return items;
      },
      isAllAllowed() {
        const role = this.user.role;
        return role === 1 || role === 12;
      }
    },
    methods: {
      editItem(item) {
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      async addToMeal(item) {
        try {
            this.loading = true;
            const response = await MealService.getMealFoods(item.id);
            this.$store.dispatch('addIngredientsToMeal', response.data);
            this.displaySnackbar('Meal ingredients added to new meal', 'blue-grey');
        } catch (e) {
          this.displaySnackbar(e.message, 'error');
        } finally {
            this.loading = false;
        }
      },
      async save() {
        const response = await MealService.updateMeal(this.editedItem);
        if (response.status >= 200 && response.status < 400) {
          this.$store.dispatch('updateMeal', this.editedItem);
        }
        this.dialog = false;
      },
      async deleteMeal(id) {
        const response = confirm('Are you sure you want to delete this item?') && await MealService.deleteMeal(id);
        if (response.status >= 200 && response.status < 400) {
          this.$store.dispatch('deleteMeal', id);
        }
      },
      getTodText(id) {
        const tod = this.tods.find((item) => item.value === id);
        if (tod) {
          return tod.text;
        } else {
          return '';
        }
      },
      formatDate(date) {
        let text = '';
        if (date !== null) {
          text = moment(date).format('Do MMM YYYY');
        }
        return text;
      },
      displaySnackbar(msg, color) {
        this.snackbarText = msg;
        this.snackbarColor = color;
        this.snackbar = true;
      },
      async addTagToMeal(tag) {
        try {
          const response = await FoodService.addTagToMeal(tag.id, this.editedItem.id);
          if (response.status >= 200 && response.status < 400) {
            this.editedItem.tags = this.editedItem.tags || [];
            this.editedItem.tags.push(tag.name);
            this.$store.dispatch('updateMeal', this.editedItem);
            this.displaySnackbar('Tag added!', 'blue-grey');
          }
        } catch (e) {
          this.displaySnackbar(e.message, 'error');
        }
      },
      async removeTag(tag) {
        const response = await TagService.removeMealTag(tag, this.editedItem.id);
        if (response.status >= 200 && response.status < 400) {
          this.editedItem.tags = this.editedItem.tags.filter((item) => item !== tag);
          this.$store.dispatch('updateMeal', this.editedItem);
          this.displaySnackbar('Tag removed!', 'blue-grey');
        }
      },
      async createTag() {
        const response = await TagService.createMealTag(this.tagName);
        if (response.status >= 200 && response.status < 400) {
          this.$store.dispatch('addMealTags', response.data);
          this.displaySnackbar('Tag created!', 'blue-grey');
        }
        this.tagDialog = false;
      },
      async deleteTag(name) {
        const response = confirm(`Are you sure you want to delete the tag '${name}'?`)
          && await TagService.deleteMealTag(name);
        if (response.status >= 200 && response.status < 400) {
          this.$store.dispatch('removeMealTag', name);
          this.displaySnackbar('Tag deleted!', 'blue-grey');
        }
      },
      async searchByTag(name) {
        this.searchTag = name;
      },
      async loadMeals() {
        let response;
        if (this.showAll) {
            response = await MealService.getAllMeals();
        } else {
            response = await MealService.getMeals();
        }
        this.$store.dispatch('setMeals', response.data);
      },
      async exportMealDialog(item) {
        this.editedItem = Object.assign({}, item);
        this.exportDialog = true;
      },
      async exportMeal() {
        if (this.editedItem.tod) {
            await MealService.exportMeal(this.exportDate, this.editedItem.id);
            this.exportDialog = false;
            this.displaySnackbar('Meal exported!', 'blue-grey');
        } else {
            this.displaySnackbar('Select a time of day for the meal before exporting', 'error');
        }
      },
      async openNutritionGraphic(id) {
        const { data } = await MealService.getMealName(id);
        window.open(`/#/chart/${data.author}/${data.name}`, '_blank');
      },
      async openNutritionGraphics() {
        window.open(`/#/charts/${this.selected}`, '_blank');
      },
      parseDate(date) {
        return moment(date).utc(0).format('dddd, MMMM Do');
      },
      async loadVersion(id) {
        try {
          this.loading = true;
          const { data } = await MealService.getMealVersions(id);
          this.mealVersions = data;
          if (data && data.length > 0) {
            this.displaySnackbar('Meal versions loaded', 'blue-grey');
          } else {
            this.displaySnackbar('No versions for this meal', 'error');
          }
        } catch (e) {
          this.displaySnackbar(e.message, 'error');
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style>

</style>
